import { useQuery } from '@tanstack/react-query';
import { adminFetch } from '@/lib/apiClient';
import { throwFromResponse } from '../lib/apiErrorMessage';
import type { AdminMemberDetail } from './useAdminUsersQuery';

export type { AdminMemberDetail };

interface AdminMemberDetailEnvelope {
  success: boolean;
  data?: AdminMemberDetail | null;
}

export const userDetailQueryKey = (userId: string, unmask = false) =>
  ['admin', 'users', 'detail', userId, { unmask }] as const;

export const useUserDetailQuery = (userId: string, unmask = true) =>
  useQuery<AdminMemberDetail>({
    queryKey: userDetailQueryKey(userId, unmask),
    queryFn: async () => {
      const qs = unmask ? '?unmask=true' : '';
      const res = await adminFetch(`/api/admin/v1/users/${userId}${qs}`);
      if (!res.ok) await throwFromResponse(res, '회원 정보를 불러오지 못했습니다.');
      const env = (await res.json()) as AdminMemberDetailEnvelope;
      if (!env.data) throw new Error('회원 정보 응답이 비어 있습니다.');
      return env.data;
    },
    enabled: Boolean(userId),
  });
